import React from 'react'
import { useField  } from 'formik'

import CustomField from './index'

const Input = ({
  label,
  dependsOn,
  hideLabel,
  a11yId,
  ...props
}) => {
  const [field, meta] = useField(props)
  const ariaDescribedby = (a11yId || field.name) + '-error'
  return (
    <CustomField
      id={props.id}
      type={props.type}
      label={label}
      field={field}
      meta={meta}
      hideLabel={hideLabel}
      dependsOn={dependsOn}
    >
      <input
        id={a11yId || field.name}
        aria-describedby={ariaDescribedby}
        {...field}
        {...props}
      />
    </CustomField>
  )
}

export default Input
